export const Etc_Emergency_TXT = []
Etc_Emergency_TXT["en"] = "Emergency Contact"
Etc_Emergency_TXT["th"] = "เบอร์โทรฉุกเฉิน"

export const Etc_Website_TXT = []
Etc_Website_TXT["en"] = "Website"
Etc_Website_TXT["th"] = "Link เว็บไซต์กลาง"